import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
//Switch
import "./App.css";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

import Navbar from "./components/Navbar";
import Main from "./components/Main";
import Main2 from "./components/Main2";
import AboutUs from "./components/AboutUs";
import Download from "./components/Download";
import Footer from "./components/Footer";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0657b8",
    },
    secondary: {
      main: "#4a148c",
    },
  },
});

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Router>
        <Navbar />
        <div id="main">....</div>
        <div className="main" style={{ margin: "3% auto 3% auto" }}>
          <Main />
        </div>
        <div id="main2"></div>
        <div className="main2" style={{ margin: "5% auto 3% auto" }}>
          <Main2 />
        </div>

        <div></div>
        <div>
          <Download />
        </div>
        <div className="our-team" id="our-team">
          <AboutUs />
        </div>

        <Footer />
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
